import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const loaderModal = props => (
  <Dimmer active={props.loading} inverted>
    <Loader inverted active={props.loading} inline="centered" />
  </Dimmer>
);
loaderModal.propTypes = {
  loading: PropTypes.bool,
};
export default loaderModal;
